// Canonical site metadata for SEO tags.
// SITE_URL is intentionally hardcoded to production: canonical URLs must point
// at membrowse.com even when the app is served from the test deployment.
export const SITE_URL = 'https://membrowse.com';
export const SITE_NAME = 'MemBrowse';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/screenshots/landing_page.png?v=20251117`;
